// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerContents: {
      width: 500,
      height: '100%',
      background: '#eee7',
      overflow: 'auto',
    },
    navigationBar: {
      background: '#dddc',
    },
  }),
);

export default useStyles;
